import { createContext } from 'react';

export const LeftSideBarContext = createContext({
  models: []
});
